import { translate } from 'helpers/translateHelper';
import { commandIdOptions, commandPatternsActions, toggleOptions, unsubscribeDisableName } from './constants';

export const getsubscriptionToggleOptions = (translate) => {
    return [{
        label: translate('ABB.Powertrain.Frontend.dataLoggerTriggerSubscribeLabel'),
        value: toggleOptions?.SUBSCRIBE
    },
    {
        label: translate('ABB.Powertrain.Frontend.dataLoggerTriggerUnsubscribeLabel'),
        value: toggleOptions?.UNSUBSCRIBE
    }];
};

// Returns the shared commandDisplayName when a command group represents a single logger type, otherwise null
export const getSharedLoggerDisplayName = (commands) => {
    if (!Array.isArray(commands) || !commands.length) {
        return null;
    }

    const displayNames = new Set(commands.map(command => command?.commandDisplayName).filter(Boolean));
    return displayNames.size === 1 ? [...displayNames][0] : null;
};

export const updatedLoggerCommands = (commands) => {
    if (!commands || !Array.isArray(commands)) {
        return [];
    }

    return commands.reduce((accCommands, currCommand) => {
        if (!currCommand) {
            return accCommands;
        }

        const commandExisting = accCommands.find(command =>
            command.commandDisplayName === currCommand.commandDisplayName &&
            command.commandType === currCommand.commandType &&
            command.loggerType === currCommand.loggerType
        );

        if (commandExisting && commandExisting.commandId) {
            commandExisting?.commandId?.push(currCommand.commandId);
        } else if (currCommand.commandId) {
            accCommands.push({
                ...currCommand,
                commandId: [currCommand.commandId]
            });
        }

        return accCommands;
    }, []);
};

export const getNotificationMessage = (commandId, commandDisplayName) => {
    const notificationMessages = {
        SUBSCRIBE: 'ABB.Powertrain.Frontend.dataLoggerSubscriptionLabel',
        UNSUBSCRIBE: 'ABB.Powertrain.Frontend.dataLoggerUnSubscriptionLabel',
        ENABLE: 'ABB.Powertrain.Frontend.dataLoggerTypeTriggeredLabel',
        DISABLE: 'ABB.Powertrain.Frontend.dataLoggerTypeStoppedLabel',
        TRIGGER: 'ABB.Powertrain.Frontend.dataLoggerTypeTriggeredLabel',
        ENABLEPSL2LOGGER: 'ABB.Powertrain.Frontend.dataLoggerSubscriptionLabel',
        DISABLEPSL2LOGGER: 'ABB.Powertrain.Frontend.dataLoggerUnSubscriptionLabel',
    };
    const commandType = Object.keys(commandIdOptions).find(key => commandId.includes(commandIdOptions[key]));
    if (!commandType) {
        return null;
    }

    const isUnsubscribeOrDisable = [
        unsubscribeDisableName.UNSUBSCRIBE,
        unsubscribeDisableName.DISABLE,
        unsubscribeDisableName.DISABLEPSL2LOGGER
    ].includes(commandType);

    const infoCommand = isUnsubscribeOrDisable ? '' : translate('ABB.Powertrain.Frontend.dataLoggerDownloadFromEventLogLabel');

    return `${commandDisplayName} ${translate(notificationMessages[commandType])} ${infoCommand}`;
};

export const executedCommand = (commandId) => {
    if (!commandId) {
        return null;
    }

    const patterns = [
        { action: 'Trigger', terms: [commandPatternsActions.ENABLE, commandPatternsActions.AMCOS] },
        { action: 'Stop', terms: [commandPatternsActions.DISABLE, commandPatternsActions.AMCOS] },
        { action: 'Subscribe', terms: [commandPatternsActions.SUBSCRIBE] },
        { action: 'Subscribe', terms: [commandPatternsActions.BLACKBOX, commandPatternsActions.SUBSCRIBE] },
        { action: 'Subscribe', terms: [commandPatternsActions.ENABLE, commandPatternsActions.PSL2] },
        { action: 'Unsubscribe', terms: [commandPatternsActions.UNSUBSCRIBE] },
        { action: 'Unsubscribe', terms: [commandPatternsActions.BLACKBOX, commandPatternsActions.UNSUBSCRIBE] },
        { action: 'Unsubscribe', terms: [commandPatternsActions.DISABLE, commandPatternsActions.PSL2] }
    ];

    return (
        patterns.find(({ terms }) => terms.every(term => commandId.includes(term)))?.action || null
    );
};
